import React, { createContext, useContext } from 'react'

interface MaldivesBundleRefreshContextValue {
  /** Set of flight item IDs currently being refreshed due to bundle eligibility changes */
  refreshingFlightIds: Set<string>
  /** Set of flight item IDs that are eligible for bundle pricing (flight + Maldives hotel with matching dates) */
  eligibleFlightIds: Set<string>
}

const defaultValue: MaldivesBundleRefreshContextValue = {
  refreshingFlightIds: new Set(),
  eligibleFlightIds: new Set(),
}

const MaldivesBundleRefreshContext = createContext<MaldivesBundleRefreshContextValue>(defaultValue)

export function useMaldivesBundleRefreshContext(): MaldivesBundleRefreshContextValue {
  return useContext(MaldivesBundleRefreshContext)
}

interface Props {
  refreshingFlightIds: Set<string>
  eligibleFlightIds: Set<string>
  children: React.ReactNode
}

export function MaldivesBundleRefreshProvider({ refreshingFlightIds, eligibleFlightIds, children }: Props) {
  return (
    <MaldivesBundleRefreshContext.Provider value={{ refreshingFlightIds, eligibleFlightIds }}>
      {children}
    </MaldivesBundleRefreshContext.Provider>
  )
}

export default MaldivesBundleRefreshContext
